import { GeneralResponse } from '../models/generalResponse'

export function saveLogs(logsRepository, contextData, logsData) {
  return logsRepository.saveLogs(contextData, logsData).then(data => new GeneralResponse(data));
}